import { Form } from 'react-bootstrap';
import { ReactComponent as VideoSearchIcon } from '../../../assets/svg/video-search.svg';
import styles from './Topbar.module.scss';

/** Mostra il modulo di ricerca desktop; lo stato e la navigazione sono gestiti dal componente padre. */
const TopbarSearch = ({ value, onChange, onSubmit, placeholder }: { value: string; onChange: (event: any) => void; onSubmit: (event: any) => void; placeholder: string }) => (
  <Form className={styles.searchForm} data-testid="topbar-search" onSubmit={onSubmit}>
    <VideoSearchIcon />
    <Form.Control value={value} onChange={onChange} placeholder={placeholder} aria-label={placeholder.replace(/\.\.\.$/, '')} />
  </Form>
);

export { TopbarSearch };
